import { Component, OnInit, ViewChild } from '@angular/core';
import {DemoService} from '../../demo.service';
// import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';

// 
import { Job } from '../../shared/models/job.model';
import { SystemFile } from '../../shared/models/file.model';
import { DatePipe } from '@angular/common';

// ag- table component

import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  IFilter } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { delay } from 'rxjs';

import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';

@Component({
  selector: 'app-communication-manager',
  templateUrl: './communication-manager.component.html',
  styleUrls: ['./communication-manager.component.css']
})
export class CommunicationManagerComponent implements OnInit {

  public data: DataManager;
  public data_subjects: DataManager;
  public pageSettings: Object;
  public pageOptions = { pageSize: 100 }; 
  public filterOptions: FilterSettingsModel;
  public formatOptions: Object;
  // public filterOptions: FilterSettingsModel;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[];
  @ViewChild('grid')
  public grid: GridComponent;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;
  initialPage: { pageSize: number; };
  subject_com_types: Object;

  constructor(
    private http: HttpClient, private router: Router, route: ActivatedRoute,private _demoService: DemoService,
    public datepipe: DatePipe
  ) { }

  ngOnInit() {

    this.getSubjectComTypesGrid(); // load the grid data

    // syncfusion GRID OPTIONS
    this.toolbarOptions = [ 'Search'];
    this.initialPage = { pageSize: 5 };
    this.filterOptions = {
      type: 'Menu'
   };
  // this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
   this.formatOptions = {type: 'date', format: 'dd/MM/yyyy'};
  // end grid options


  }



  private getSubjectComTypesGrid() {
    this._demoService.getSubjectComTypesGrid()
      .subscribe(
        res => this.subject_com_types = res,
        err => console.error(err.status)
      );
  }

  // Grid Functions
  toolbarClick(args: ClickEventArgs): void {
    if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
        this.grid.excelExport();
    }
  }
  rowDataBound(args: RowDataBoundEventArgs) {
    const job_status = 'job_status';
    if (args.data[job_status] === 'CLOSED') {
        args.row.className = 'strikethrough';
    }
  }

  refreshGrid(){ // refresh the databutton
    this.getSubjectComTypesGrid();
    this.grid.refresh();
  };


  gridItemView(id) {
    this.router.navigate(['/admin/communication/com_type_view/' + id + '']);
  }

  gridItemEdit(id) {
    this.router.navigate(['/admin/communication/com_type_edit/' + id + '']);
  }


  // end grid functions

}
